module.exports = __webpack_public_path__ + "static/media/gasPedal.476db15f.png";